import methods from "@/utils/tools";
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: methods,
};
